import * as S from './Carousel.styled'

export const Root = S.Wrapper
export const Slider = S.Slider
export const Item = S.Item
export const ContentLeft = S.ContentLeft
export const NavButton = S.NavigationButton
export const ItemText = S.ItemText
export const ItemEmote = S.ItemEmote
export const ItemGradient = S.GradientOverlay
